import getExtendedProperty from './getExtendedProperty';
import type BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import { REPLICA_LIST_EXTENDED_PROPERTY_TAG } from './replicaListConstant';

export function getReplicaListProperty(folderItem: BaseFolderType): string[] | null {
    // Return the replica list if it is already available on the folderItem
    // This is the case when the folderItem is a result of a getFolder request
    if (folderItem.ReplicaList) {
        return folderItem.ReplicaList;
    }

    const replicaListBase64Encoded = getExtendedProperty(
        folderItem,
        REPLICA_LIST_EXTENDED_PROPERTY_TAG
    );

    if (replicaListBase64Encoded) {
        // Decode the Base-64 format encoded (binary form) replica guid to text.
        // The binary form Guids have null character at the end so remove it.
        const decoded = atob(replicaListBase64Encoded);
        const replicaGuid = decoded.substr(0, decoded.length - 1);
        return [replicaGuid];
    }

    return null;
}
